<template>
  <div>
    <div>
      <div class="page-header">
        <p class="page-title">{{ $t('profile.titles.profile') }}</p>
        <b-button class="px-0" variant="transparent" @click="edit()">
          <svg-icon name="edit3" class="fill-icon icon-primary" size="24"></svg-icon>
        </b-button>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="clearfix mb-4 mt-2">
            <span class="float-left text-muted">{{ $t('form.name.label') }}</span>
            <span class="float-right">{{ user.firstName + ' ' + user.secondName }}</span>
          </p>
          <p class="clearfix mb-4 mt-2">
            <span class="float-left text-muted">{{ $t('form.email.label') }}</span>
            <span class="float-right text-lowercase">{{ user.login }}</span>
          </p>
          <p class="clearfix">
            <span class="float-left text-muted">{{ $t('form.phone.label') }}</span>
            <span class="float-right">{{ user.phoneBusiness }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartOeeProfileCards',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    edit() {
      this.$emit('editProfile');
    },
  },
};
</script>

<style></style>
